import { createSlice } from "@reduxjs/toolkit";
import { reset } from "../actions";

const initialState = {
  page: 0,
  data: {
    orderForm:51,
  },
  customerInformation: {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    jobTitle:"",
    company: "",
    principalInvestigator: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    channel: "",
  },
  quoteDetails: {
    description: "",
    comments: "",
    serviceInterest:"",
    serviceLevel:"",
  },
};

const quoteRequestSlice = createSlice({
  name: "quoteRequestorderform",
  initialState,
  reducers: {
    //action creators
    resetQuoteRequestState(state, action) {
      Object.assign(state, initialState);
      return;
    },
    quoteRequestPrevStep: (state, action) => {
      state.page = state.page - 1;
    },
    quoteRequestNextStep: (state, action) => {
      state.page = state.page + 1;
    },
    quoteRequestSetStep: (state, action) => {
      state.page = action.payload;
    },
    resetQuoteRequestPage: (state, action) => {
      state.page = action.payload;
    },
    setQuoteRequestServiceInterest: (state, action) => {
      state.quoteDetails.serviceInterest = action.payload;
    },
    setQuoteRequestServiceLevel: (state, action) => {
      state.quoteDetails.serviceLevel = action.payload;
    },
    setQuoteRequestDescription: (state, action) => {
      state.quoteDetails.description = action.payload;
    },
    setQuoteRequestComments: (state, action) => {
      state.quoteDetails.comments = action.payload;
    },
    setQuoteRequestDropboxLocation(state, action) {
      state.customerInformation.dropboxLocation = action.payload.label;
      return;
    },
    setQuoteRequestDropoffDate(state, action) {
      state.customerInformation.dropoffDate = action.payload;
      return;
    },
    setQuoteRequestFirstName(state, action) {
      state.customerInformation.firstName = action.payload;
      return;
    },
    setQuoteRequestLastName(state, action) {
      state.customerInformation.lastName = action.payload;
      return;
    },
    setQuoteRequestAddress(state, action) {
      state.customerInformation.address = action.payload;
      return;
    },
    setQuoteRequestCity(state, action) {
      state.customerInformation.city = action.payload;
      return;
    },
    setQuoteRequestState(state, action) {
      state.customerInformation.state = action.payload;
      return;
    },
    setQuoteRequestZip(state, action) {
      state.customerInformation.zip = action.payload;
      return;
    },
    setQuoteRequestCompany(state, action) {
      state.customerInformation.company = action.payload;
    },
    setQuoteRequestJobtitle(state, action) {
      state.customerInformation.jobTitle = action.payload;
    },
    setQuoteRequestPI(state, action) {
      state.customerInformation.principalInvestigator = action.payload;
    },
    setQuoteRequestChannel(state, action) {
      state.customerInformation.channel = action.payload;
    },
    setQuoteRequestPhone(state, action) {
      const result = action.payload;
      state.customerInformation.phone = result;
    },
    setQuoteRequestEmail(state, action) {
      state.customerInformation.email = action.payload;
    },
    setQuoteRequestShippingOption(state, action) {
      state.customerInformation.shippingOption = action.payload;
      return;
    },
    setQuoteRequestAcgtCard(state, action) {
      state.customerInformation.acgtCard = action.payload;
      return;
    },
    setQuoteRequestCCNumber(state, action) {
      state.customerInformation.ccNumber = action.payload;
      return;
    },
    setQuoteRequestCCMonth(state, action) {
      state.customerInformation.ccMonth = action.payload;
      return;
    },
    setQuoteRequestCCYear(state, action) {
      state.customerInformation.ccYear = action.payload;
      return;
    },
    setQuoteRequestCVV(state, action) {
      state.customerInformation.cvv = action.payload;
      return;
    },
    setQuoteRequestCCName(state, action) {
      state.customerInformation.ccName = action.payload;
      return;
    },
    setQuoteRequestCardType(state, action) {
      state.customerInformation.cardType = action.payload;
      return;
    },
    setQuoteRequestBillingMethod(state, action) {
      state.customerInformation.billingMethod = action.payload;
      return;
    },
    setQuoteRequestPurchasingAgentName(state, action) {
      state.customerInformation.purchasingAgentName = action.payload;
      return;
    },
    setQuoteRequestPurchasingAgentEmail(state, action) {
      state.customerInformation.purchasingAgentEmail = action.payload;
      return;
    },
    setQuoteRequestPoNumber(state, action) {
      state.customerInformation.poNumber = action.payload;
      return;
    },
  },
  //tell our combined reducer to look for additional action types
  extraReducers(builder) {
    builder.addCase(reset, (state, action) => {
      return {};
    });
  },
});

export const {
  resetQuoteRequestState,
  quoteRequestNextStep,
  quoteRequestPrevStep,
  quoteRequestSetStep,
  resetQuoteRequestPage,
  setQuoteRequestServiceInterest,
  setQuoteRequestServiceLevel,
  setQuoteRequestDescription,
  setQuoteRequestComments,
  setQuoteRequestDropoffDate,
  setQuoteRequestDropboxLocation,
  setQuoteRequestFirstName,
  setQuoteRequestLastName,
  setQuoteRequestAddress,
  setQuoteRequestCity,
  setQuoteRequestState,
  setQuoteRequestZip,
  setQuoteRequestCompany,
  setQuoteRequestJobtitle,
  setQuoteRequestPI,
  setQuoteRequestChannel,
  setQuoteRequestPhone,
  setQuoteRequestEmail,
  setQuoteRequestShippingOption,
  setQuoteRequestAcgtCard,
  setQuoteRequestCCNumber,
  setQuoteRequestCCMonth,
  setQuoteRequestCCYear,
  setQuoteRequestCVV,
  setQuoteRequestCCName,
  setQuoteRequestCardType,
  setQuoteRequestPurchasingAgentName,
  setQuoteRequestPurchasingAgentEmail,
  setQuoteRequestPoNumber,
  setQuoteRequestBillingMethod,
} = quoteRequestSlice.actions;
export const quoteRequestReducer = quoteRequestSlice.reducer;
